import { makeDataState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  starEvent: makeDataState(),
  starEventDashboard: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_STAR_EVENT}_SUCCESS`:
      return {
        ...state,
        starEvent: {
          ...state.starEvent,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_STAR_EVENT_DASHBOARD}_SUCCESS`:
      return {
        ...state,
        starEventDashboard: {
          ...state.starEventDashboard,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.POST_STAR_EVENT_REWARD}_SUCCESS`:
      return {
        ...state,
        starEventDashboard: {
          ...state.starEventDashboard,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: {
            ...state.starEventDashboard.data,
            currentReward:
              state.starEventDashboard.data.currentReward - action.meta.cost,
            prizes: [
              ...(action.payload.result.prize
                ? [action.payload.result.prize].concat(
                    state.starEventDashboard.data.prizes
                  )
                : state.starEventDashboard.data.prizes),
            ],
          },
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/events/consume/reducer.js